const { apcLogService } = window;

const safeWrap = prop => (...args) => {
    if (!apcLogService) return null;

    return apcLogService[prop](...args);
};

const PAGE = 'tradUpsOverview';
const matchThisOrChildren = safeWrap('matchThisOrChildren');
const closest = safeWrap('getClosest');
const preload = safeWrap('preload');
const setPageReady = safeWrap('setPageReady');
const setVariables = safeWrap('setVariables');
const getDefaultPageReadyPromise = safeWrap('getDefaultPageReadyPromise');

preload(PAGE);

function trackTradeUpsClick({ target }) {
    if (matchThisOrChildren(target, '.analytics-add')) {
        apcLogService(`${PAGE}.clickCatchAll.clickAdd`, {
            target,
        });
    } else if (matchThisOrChildren(target, '.analytics-chooseNewUps a')) {
        const manufactures = [...document.querySelectorAll('.analytics-manufacture span')];
        const skus = [...document.querySelectorAll('.analytics-sku')];

        apcLogService(`${PAGE}.clickCatchAll.clickChooseNew`, {
            target,
            used_ups: manufactures.map((item, i) => ({ UPS_manufacturer: item.innerHTML, SKU: skus[i].innerHTML })),
        });
    } else if (matchThisOrChildren(target, '.breadcrumb a')) {
        const cat2 = closest(target, '.breadcrumb a').getAttribute('data-item-name');
        const cat3 = window.tc_vars && window.tc_vars.page_name;
        apcLogService(`${PAGE}.clickProductOffer.clickBreadcrumb`, {
            target,
            event_cat1: 'Breadcrumbs',
            event_cat2: cat2,
            event_cat3: cat3,
            event_name: `Breadcrumbs_${cat2}_${cat3}`,
        });
    }
}
try {
    setPageReady(
        getDefaultPageReadyPromise()
            .then(() => {
                document.body.addEventListener('click', trackTradeUpsClick);

                try {
                    setVariables({
                        env_template: 'tradeups',
                        page_name: 'tradeups-overview',
                        page_cat1: 'Overview',
                        page_cat2: 'Trade-ups',
                        page_cat3: 'Step-1',
                        page_level: '199',
                        sales_insights: '1',
                    });
                } catch (e) {
                    console.error('Failed to setup variables\r\n', e);
                }
            })
            // eslint-disable-next-line no-console
            .catch(err => console.error(`There is an error on getting page ready state\r\n`, err)),
    );
} catch (err) {
    console.log(err);
}
